// import tooltipIcon from 'assets/icons/tooltip.svg'

import { formatPercentageWithSign } from 'toolbox/format'

export type Value = number | string
export interface SubValue {
  subVal: number
  isPostive: boolean
}

export interface DataPointProps {
  value: Value
  label?: string
  isLoading?: boolean
  horizontal?: boolean
  right?: boolean
  tooltip?: string
  onlyVal?: boolean
  colorBox?: string
  flip?: boolean
  light?: boolean
  subValue?: SubValue
  secondaryValue?: Value
  currentColor?: string
  large?: boolean
  hideMobile?: boolean
}

const DataPoint = ({
  label,
  value,
  horizontal,
  right,
  tooltip,
  onlyVal,
  colorBox,
  flip,
  light,
  subValue,
  secondaryValue,
  currentColor,
  large,
  hideMobile
}: DataPointProps) => {
  if (hideMobile) return null
  const hrz = horizontal ? 'is-horizontal' : ''
  const rt = right ? 'is-right' : ''
  const dis =
    value === '--' || value === '0' || value === '$0' || value === '$0.00' || value === 'N/A'
      ? 'disabled'
      : ''
  const only = onlyVal ? 'only-val' : ''
  if (value === '$0' || value === '$0.00') {
    value = '0'
  }
  const secondaryClass = secondaryValue ? 'secondary' : ''
  const thin = tooltip ? 'thin-lined' : ''
  const lightClass = light ? 'light' : ''
  const positiveClass = subValue?.isPostive ? 'positive' : 'negative'
  const largeClass = large ? 'large' : ''
  return !flip ? (
    <div className={'outer-data-point'}>
      {colorBox && <div className={`color-box ${colorBox}`} />}
      <div className={`sp-data-point ${hrz} ${rt} ${thin} ${secondaryClass} ${largeClass}`}>
        <div className="label-wrap">
          <div className="tip-box">
            <p className={`label tooltip ${lightClass}`}>{label}</p>
            {!!tooltip && (
              <div className="tip-value">
                <p>{tooltip}</p>
              </div>
            )}
          </div>
        </div>
        <p className={`value ${dis} ${only} ${lightClass} ${currentColor}`}>{value}</p>
        {subValue && (
          <p className={`sub-value ${positiveClass}`}>
            {formatPercentageWithSign(subValue.subVal)}
          </p>
        )}
      </div>
      {secondaryValue && <p className={`secondary-value ${dis}`}>{secondaryValue}</p>}
    </div>
  ) : (
    <div className={'outer-data-point'}>
      {colorBox && <div className={`color-box ${colorBox}`} />}
      <div className={`sp-data-point ${hrz} ${rt} ${thin} ${secondaryClass}`}>
        <p className={`value ${dis} ${only} ${currentColor}`}>{value}</p>
        <div className="label-wrap">
          <div className="tip-box">
            <p className="label tooltip">{label}</p>
            {!!tooltip && (
              <div className="tip-value">
                <p>{tooltip}</p>
              </div>
            )}
          </div>
        </div>
      </div>
      {secondaryValue && <p className={`secondary-value ${dis}`}>{secondaryValue}</p>}
    </div>
  )
}

export default DataPoint
